var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"axt-container content-bg",class:{
  isMobile: _vm.isMobile()
}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-box"},[_c('iframe',{attrs:{"src":"https://www.aixuetang.com/","frameborder":"0"}})])
}]

export { render, staticRenderFns }